module.exports = __webpack_public_path__ + "static/img/feixue.9e252b81.png";